import { JsonObject } from '@/lib/helpers';
import { PreferencesModel } from './preferences.model';
import { BaseModel, CreateBaseModel } from '../base.model';

export class UserSettingsModel extends BaseModel {
  admin: {
    preferences: PreferencesModel;
  };

  constructor(props: JsonObject = {}) {
    super(props);
    const admin = (props.admin as JsonObject) || {};
    const { preferences } = admin;

    this.admin = {
      preferences: new PreferencesModel((preferences as JsonObject) || {}),
    };
  }
}

export class CreateUserSettingsModel extends CreateBaseModel {
  admin: {
    preferences: PreferencesModel;
  };

  constructor(settings: UserSettingsModel) {
    super();
    this.admin = settings.admin;
  }
}
